/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface CreateTeamResponse
 */
export interface CreateTeamResponse {
    /**
     * 
     * @type {ITeamResponse}
     * @memberof CreateTeamResponse
     */
    team: ITeamResponse;
}

/**
 * Check if a given object implements the CreateTeamResponse interface.
 */
export function instanceOfCreateTeamResponse(value: object): value is CreateTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function CreateTeamResponseFromJSON(json: any): CreateTeamResponse {
    return CreateTeamResponseFromJSONTyped(json, false);
}

export function CreateTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': ITeamResponseFromJSON(json['team']),
    };
}

export function CreateTeamResponseToJSON(json: any): CreateTeamResponse {
    return CreateTeamResponseToJSONTyped(json, false);
}

export function CreateTeamResponseToJSONTyped(value?: CreateTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': ITeamResponseToJSON(value['team']),
    };
}

